import { Box, Button, Tooltip } from '@mui/material';
import { useAtom } from 'jotai';

import { EntryType } from 'openapi';

import { useTranslations } from 'context/TranslationContext';

import { DocumentConfig } from 'utils/config/documentEntries';

import { isRequestPendingAtom } from 'state/state';

interface ActionButtonsProps {
  isFormValid?: boolean;
  shouldVerify?: boolean;
  handleBack?: () => void;
  handleCreate?: () => void;
  documentConfig?: DocumentConfig;
}

export const ActionButtons = ({
  isFormValid,
  shouldVerify,
  handleBack,
  handleCreate,
  documentConfig
}: ActionButtonsProps) => {
  const { translate } = useTranslations();
  const [isRequestPending] = useAtom(isRequestPendingAtom);

  const getVerifyButtonLabel = () => {
    if (shouldVerify && documentConfig?.entryType === EntryType.REVENUE) {
      return translate('buttons.verify');
    }
    if (shouldVerify) {
      return translate('buttons.sendForApproval');
    }
    return translate('buttons.next');
  };

  return (
    <Box
      sx={{
        pb: 3,
        display: 'flex',
        justifyContent: handleBack ? 'space-between' : 'flex-end',
        alignItems: 'center'
      }}
    >
      {handleBack && (
        <Button
          onClick={handleBack}
          variant="outlined"
          color="primary"
          disabled={isRequestPending}
        >
          {translate('buttons.back')}
        </Button>
      )}
      {handleCreate && (
        <Button
          onClick={handleCreate}
          variant="contained"
          color="primary"
          disabled={isRequestPending}
        >
          {translate('buttons.create')}
        </Button>
      )}
      {!handleCreate && (
        <Tooltip
          placement="left"
          title={!isFormValid ? translate('messages.formIsInvalid') : ''}
        >
          <span>
            <Button
              disabled={!isFormValid || isRequestPending}
              type="submit"
              variant="contained"
              color="primary"
            >
              {getVerifyButtonLabel()}
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
